import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { IResponse } from '../model/server_response';

@Injectable()
export class TradingPartnerService extends GeneralService {
  formActions: { [key: string]: string } = {
    SUBMITTING: 'SUBMITTING',
    SAVING: 'SAVING',
  };
  frameTypes = ['DAYS', 'WEEKS', 'MONTHS', 'YEARS'];

  constructor(protected http: HttpClient) {
    super(http);
  }

  public getFormActions() {
    return this.formActions;
  }

  public getFrameTypes() {
    return this.frameTypes;
  }

  public getTradingPartners(page): Observable<IResponse<any>> {
    const current_page = page.pageNumber;
    let params = new HttpParams();
    params = params.append('perPage', page.size);
    params = params.append('page', current_page);
    if (!_.isUndefined(page.sortParams)) {
      for (const key of Object.keys(page.sortParams)) {
        const value = page.sortParams[key];
        params = params.append('sort[]', key + ',' + value);
      }
    }
    if (!_.isUndefined(page.filterParams)) {
      for (const key of Object.keys(page.filterParams)) {
        const value = page.filterParams[key];
        if (value !== undefined && value !== '') {
          params = params.append(key, value);
        }
      }
    }
    return this.http.get<IResponse<any>>(this.apiUrl + '/trading-partners', {
      params: params,
    });
  }

  public preloadData(): Observable<any> {
    return this.http.get(this.apiUrl + '/vendors/preload');
  }

  public getNewFieldsData(fieldType: string): Observable<any> {
    const url = `${this.apiUrl}/trading-partners/get-new-fields`;
    return this.http
        .get(url, {params: {fieldType: fieldType}})
        .catch(this.handleError);
  }

  public getVendor(id: number, CO1_ID: string = null) {
    const url = `${this.apiUrl + '/trading-partners/vendor'}/${id}/${CO1_ID}`;
    return this.http.get(url).catch(this.handleError);
  }

  public addVendor(
      vendor,
      ticket,
      action,
      fileList: any[] = null,
      files: any[] = null
  ) {
    const url = `${this.apiUrl + '/trading-partners/vendor'}`;
    const data = {
      vendor: vendor,
      action: action,
      ticket: ticket,
      fileList: fileList,
    };

    let formData = new FormData();
    files.forEach((element) => {
      formData.append(element.name, element);
    });

    formData.append('data', JSON.stringify(data));
    return this.http
        .post(url, formData)
        .do((data) => console.log('insert vendor: ' + JSON.stringify(data)))
        .catch(this.handleError);
  }

  public updateVendor(
      vendor,
      ticket,
      action,
      fileList: any[] = null,
      files: any[] = null
  ) {
    const url = `${this.apiUrl + '/trading-partners/vendor'}/${vendor.VD1_ID}/${
        vendor.CO1_ID
    }`;
    const data = {
      vendor: vendor,
      action: action,
      ticket: ticket,
      fileList: fileList,
    };

    let formData = new FormData();
    files.forEach((element) => {
      formData.append(element.name, element);
    });

    formData.append('data', JSON.stringify(data));
    formData.append('_method', 'PUT');

    return this.http
        .post(url, formData)
        .do((data) => console.log('update vendor: ' + JSON.stringify(data)))
        .catch(this.handleError);
  }

  public getCustomer(id: number, CO1_ID: string = null) {
    const url = `${this.apiUrl + '/trading-partners/customer'}/${id}/${CO1_ID}`;
    return this.http.get(url).catch(this.handleError);
  }

  public addCustomer(
      customer,
      ticket,
      action,
      fileList: any[] = null,
      files: any[] = null
  ) {
    const url = `${this.apiUrl + '/trading-partners/customer'}`;
    const data = {
      customer: customer,
      action: action,
      ticket: ticket,
      fileList: fileList,
    };

    const formData = new FormData();
    files.forEach((element) => {
      formData.append(element.name, element);
    });

    formData.append('data', JSON.stringify(data));

    return this.http
        .post(url, formData)
        .do(() => console.log('insert customer: ' + JSON.stringify(data)))
        .catch(this.handleError);
  }

  public updateCustomer(
      customer,
      ticket,
      action,
      fileList: any[] = null,
      files: any[] = null
  ) {
    const url = `${this.apiUrl + '/trading-partners/customer'}/${
        customer.CU1_ID
    }/${customer.CO1_ID}`;
    const data = {
      customer: customer,
      action: action,
      ticket: ticket,
      fileList: fileList,
    };

    const formData = new FormData();
    files.forEach((element) => {
      formData.append(element.name, element);
    });

    formData.append('data', JSON.stringify(data));
    formData.append('_method', 'PUT');

    return this.http
        .post(url, formData)
        .do(() => console.log('update customer: ' + JSON.stringify(data)))
        .catch(this.handleError);
  }

  public getTradingPartnerFile(fileId: number): Observable<any> {
    const url = `${this.apiUrl + '/trading-partners/file'}/${fileId}`;
    return this.http
        .get(url, {
          responseType: 'blob',
        })
        .catch(this.handleError);
  }

  public saveToModifiedLog(
      customer,
      vendor,
      logData
  ): Observable<any> {
    let id;
    let companyId;

    if (customer) {
      id = customer.CU1_ID;
      companyId = customer.CO1_ID;
    } else
    if (vendor) {
      id = vendor.VD1_ID;
      companyId = vendor.CO1_ID;
    }

    const url = `${this.apiUrl + '/trading-partners/modified-log-save'}`;
    const data = {
      id: id,
      companyId: companyId,
      customer: customer?1:0,
      vendor: vendor?1:0,
      logData: logData
    };

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));

    return this.http
        .post(url, formData)
        .do(() => console.log('save to modified log: ' + JSON.stringify(data)))
        .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/trading-partner.service.ts